import { Box, Button } from "@mui/material";
import React, { useState } from "react";
import { useQueryClient } from "react-query";
import ChipCmp from "../../../components/chip/chipCmp";
import MaterialTextFieldComponent from "../../../components/textField/MaterialTextFieldCmp";
import { GetAllCustomerInfoFilter } from "../../../models/customer.model";

interface Props {
  setFilterObject: (filterObj: GetAllCustomerInfoFilter) => void;
  filterObject: GetAllCustomerInfoFilter;
  setCurrentPaginationInfo: (page: any) => void;
}

const CustormerInfoListFilters = ({
  filterObject,
  setCurrentPaginationInfo,
  setFilterObject,
}: Props) => {
  const [formData, setFormData] = useState<GetAllCustomerInfoFilter>();
  const queryClient = useQueryClient();

  const handleChangeForm = (event: any) => {
    setFormData({ ...formData!, [event.target.id]: event.target.value });
    queryClient.setQueryData<GetAllCustomerInfoFilter>(
      "GetAllCustomerInfoFilter",
      { ...formData!, [event.target.id]: event.target.value }
    );
  };

  const handleChip = (e: any, id: string) => {
    let tableFilter = queryClient.getQueryData<GetAllCustomerInfoFilter>(
      "GetAllCustomerInfoFilter"
    );
    tableFilter = {
      ...tableFilter!,
      [id]: "",
    };
    setFormData({ ...formData!, [id]: "" });
    queryClient.setQueryData<GetAllCustomerInfoFilter>(
      "GetAllCustomerInfoFilter",
      tableFilter
    );
    setFilterObject(tableFilter);
  };
  const deleteChip = () => {
    let tableFilter = queryClient.getQueryData<GetAllCustomerInfoFilter>(
      "GetAllCustomerInfoFilter"
    );
    tableFilter = undefined;
    setFormData({
      customerMobileNumber: "",
      customerName: "",
      customerNationalCode: "",
      customerShenasnamehNumber: "",
    });
    queryClient.setQueryData<GetAllCustomerInfoFilter>(
      "GetAllCustomerInfoFilter",
      tableFilter!
    );
    setFilterObject(tableFilter!);
  };
  const handleFormSubmit = () => {
    let tableFilter = queryClient.getQueryData<GetAllCustomerInfoFilter>(
      "GetAllCustomerInfoFilter"
    );
    tableFilter = {
      ...tableFilter!,
    };
    queryClient.setQueryData<GetAllCustomerInfoFilter>(
      "GetAllCustomerInfoFilter",
      tableFilter
    );
    setCurrentPaginationInfo({
      pageNumber: 1,
      pageSize: 10,
    });

    setFilterObject(tableFilter);
  };
  return (
    <div>
      <Box>
        <div className='row'>
          <div
            className='col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12'
            style={{ marginTop: "1vh" }}
          >
            <MaterialTextFieldComponent
              helperText={""}
              placeHolder={"متقاضی"}
              label={"متقاضی"}
              required={false}
              value={formData?.customerName}
              onChange={(e: any) => handleChangeForm(e)}
              name='customerName'
              id='customerName'
            />
          </div>
          <div
            className='col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12'
            style={{ marginTop: "1vh" }}
          >
            <MaterialTextFieldComponent
              helperText={""}
              placeHolder={"کد ملی متقاضی"}
              label={"کد ملی متقاضی"}
              required={false}
              value={formData?.customerNationalCode}
              onChange={(e: any) => handleChangeForm(e)}
              name='customerNationalCode'
              id='customerNationalCode'
              onKeyDown={(event) => {
                if (
                  event.code === "Space" ||
                  (!/^[0-9]$/.test(event.key) && event.code !== "Backspace")
                )
                  event.preventDefault();
              }}
            />
          </div>
          <div
            className='col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12'
            style={{ marginTop: "1vh" }}
          >
            <MaterialTextFieldComponent
              helperText={""}
              placeHolder={"شماره شناسنامه"}
              label={"شماره شناسنامه"}
              required={false}
              value={formData?.customerShenasnamehNumber}
              onChange={(e: any) => handleChangeForm(e)}
              name='customerShenasnamehNumber'
              id='customerShenasnamehNumber'
              onKeyDown={(event) => {
                if (
                  event.code === "Space" ||
                  (!/^[0-9]$/.test(event.key) && event.code !== "Backspace")
                )
                  event.preventDefault();
              }}
            />
          </div>
          <div
            className='col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12'
            style={{ marginTop: "1vh" }}
          >
            <MaterialTextFieldComponent
              helperText={""}
              placeHolder={"شماره همراه"}
              label={"شماره همراه"}
              required={false}
              value={formData?.customerMobileNumber}
              onChange={(e: any) => handleChangeForm(e)}
              name='customerMobileNumber'
              id='customerMobileNumber'
              onKeyDown={(event) => {
                if (
                  event.code === "Space" ||
                  (!/^[0-9]$/.test(event.key) && event.code !== "Backspace")
                )
                  event.preventDefault();
              }}
            />
          </div>
          <div
            className='col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12 butFilter'
            style={{ marginTop: "1vh" }}
          >
            <Button
              fullWidth
              variant='contained'
              className='btnForm SuccessDefault  '
              onClick={handleFormSubmit}
            >
              اعمال فیلتر
            </Button>
          </div>
        </div>

        {/*  chips */}
        {(formData?.customerMobileNumber ||
          formData?.customerName ||
          formData?.customerNationalCode ||
          formData?.customerShenasnamehNumber) && (
          <div
            style={{ display: "flex", alignItems: "center" }}
            className='row tableCMP'
          >
            <Button
              onClick={deleteChip}
              style={{
                justifyContent: "right",
                minWidth: "25px",
                marginRight: "-1vh",
                marginTop: "1vh",
              }}
            >
              <img
                style={{ height: "24px", width: "24px" }}
                src='images/RemoveAllFilters.svg'
                alt='remove'
              />
            </Button>
            {Object.keys(formData || {}).map((key) => (
              <ChipCmp
                key={key}
                item={(formData as any)[key]}
                enamValue={(formData as any)[key]}
                index={(formData as any)[key]?.length}
                setChildValue={(e: any) => handleChip(e, key)}
              />
            ))}
          </div>
        )}
      </Box>
    </div>
  );
};

export default CustormerInfoListFilters;
